/* istanbul ignore file */


import React, { ReactElement } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { adminState } from './app-state/user-state';
import './App.css';
import Footer from './components/footer/Footer';
import Header from 'components/header/Header';
import ContactPage from 'components/page/contact/Contact';
import HomePage from 'components/page/home/Home';
import ErrorPage from 'components/page/error/Error';
import ShopPage from 'components/page/shop/Shop';
import CartPage from 'components/page/cart/Cart';
import CheckoutPage from 'components/page/checkout/Checkout';
import OrderPage from 'components/page/checkout/Order';
import AdminPage from 'components/page/admin/Admin';
import ProductEditorPage from 'components/page/admin/product/editor/ProductEditor';
import ProductCreatorPage from 'components/page/admin/product/creator/ProductCreator';
import VoucherEditorPage from 'components/page/admin/voucher/editor/VoucherEditor';
import VoucherCreatorPage from 'components/page/admin/voucher/creator/VoucherCreator';

const App = (): ReactElement => {
  const isAdmin = useRecoilValue(adminState);

  return <div id='app-root' className="App bg-primary pb-4 min-h-screen">
    <Router>
      <Header />
      <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        <Route path="/home">
          <Redirect to="/" />
        </Route>
        <Route path="/contact">
          <ContactPage />
        </Route>
        <Route path="/shop">
          <ShopPage />
        </Route>
        <Route path="/cart">
          <CartPage />
        </Route>
        <Route path="/order/:orderNumber">
          <OrderPage />
        </Route>
        <Route path="/checkout">
          <CheckoutPage />
        </Route>
        <Route path="/admin/products">
          {isAdmin ? <AdminPage mode='Products' /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/vouchers">
          {isAdmin ? <AdminPage mode='Vouchers' /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/status">
          {isAdmin ? <AdminPage mode='Status' /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/features">
          {isAdmin ? <AdminPage mode='Features' /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/product-creator">
          {isAdmin ? <ProductCreatorPage /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/voucher-creator">
          {isAdmin ? <VoucherCreatorPage /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/product-editor/:id">
          {isAdmin ? <ProductEditorPage /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="/admin/voucher-editor/:code">
          {isAdmin ? <VoucherEditorPage /> : <ErrorPage heading="Access Denied" />}
        </Route>
        <Route path="*">
          <ErrorPage heading="404 Not Found" />
        </Route>
      </Switch>
      <Footer />
    </Router>
  </div>;
};

export default App;
